import { AbstractFlow3bixaw6q3bbim as AbstractFlow } from './Flow.mjs';
import { $3l5vvh8yg0ier as $ } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ChannelFlowvdfy82kdxy2m as ChannelFlow } from './internal/ChannelFlow.mjs';
import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { BufferOverflow_SUSPEND_getInstance1ucmryz5dsuc2 as BufferOverflow_SUSPEND_getInstance } from '../channels/BufferOverflow.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function flow(block) {
  return new (SafeFlow())(block);
}
function asFlow(_this__u8e3s4) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (asFlow$$inlined$unsafeFlow$1())(_this__u8e3s4);
}
var SafeFlowClass;
function SafeFlow() {
  if (SafeFlowClass === VOID) {
    class $_0 extends AbstractFlow() {
      constructor(block) {
        super();
        this.r1d_1 = block;
      }
      *s1d(collector, $completion) {
        yield* $(this.r1d_1(collector, $completion), $completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($_0, 'SafeFlow', VOID, VOID, VOID, [1]);
    SafeFlowClass = $_0;
  }
  return SafeFlowClass;
}
function channelFlow(block) {
  return new (ChannelFlowBuilder())(block);
}
function flowOf(value) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (flowOf$$inlined$unsafeFlow$1())(value);
}
function callbackFlow(block) {
  return new (CallbackFlowBuilder())(block);
}
var ChannelFlowBuilderClass;
function ChannelFlowBuilder() {
  if (ChannelFlowBuilderClass === VOID) {
    class $_0 extends ChannelFlow() {
      constructor(block, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -2 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(context, capacity, onBufferOverflow);
        this.x1d_1 = block;
      }
      y1d(context, capacity, onBufferOverflow) {
        return new (ChannelFlowBuilder())(this.x1d_1, context, capacity, onBufferOverflow);
      }
      *z1d(scope, $completion) {
        return yield* $(this.x1d_1(scope, $completion), $completion);
      }
      toString() {
        return 'block[' + toString(this.x1d_1) + '] -> ' + super.toString();
      }
    }
    initMetadataForClass($_0, 'ChannelFlowBuilder', VOID, VOID, VOID, [1]);
    ChannelFlowBuilderClass = $_0;
  }
  return ChannelFlowBuilderClass;
}
var CallbackFlowBuilderClass;
function CallbackFlowBuilder() {
  if (CallbackFlowBuilderClass === VOID) {
    class $ extends ChannelFlowBuilder() {
      constructor(block, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -2 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(block, context, capacity, onBufferOverflow);
        this.n1e_1 = block;
      }
      *z1d(scope, $completion) {
        yield* protoOf(ChannelFlowBuilder()).z1d.call(this, scope, $completion);
        if (!scope.p1b()) {
          throw IllegalStateException().o("'awaitClose { yourCallbackOrListener.cancel() }' should be used in the end of callbackFlow block.\nOtherwise, a callback/listener may leak in case of external cancellation.\nSee callbackFlow API documentation for the details.");
        }
        return Unit_instance;
      }
      y1d(context, capacity, onBufferOverflow) {
        return new (CallbackFlowBuilder())(this.n1e_1, context, capacity, onBufferOverflow);
      }
    }
    initMetadataForClass($, 'CallbackFlowBuilder', VOID, VOID, VOID, [1]);
    CallbackFlowBuilderClass = $;
  }
  return CallbackFlowBuilderClass;
}
var asFlow$$inlined$unsafeFlow$1Class;
function asFlow$$inlined$unsafeFlow$1() {
  if (asFlow$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_asFlow) {
        this.o1e_1 = $this_asFlow;
      }
      *p1e(collector, $completion) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.o1e_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          yield* collector.q1e(element, $completion);
        }
        return Unit_instance;
      }
      t1d(collector, $completion) {
        return this.p1e(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    asFlow$$inlined$unsafeFlow$1Class = $;
  }
  return asFlow$$inlined$unsafeFlow$1Class;
}
var flowOf$$inlined$unsafeFlow$1Class;
function flowOf$$inlined$unsafeFlow$1() {
  if (flowOf$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($value) {
        this.r1e_1 = $value;
      }
      *p1e(collector, $completion) {
        yield* collector.q1e(this.r1e_1, $completion);
        return Unit_instance;
      }
      t1d(collector, $completion) {
        return this.p1e(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    flowOf$$inlined$unsafeFlow$1Class = $;
  }
  return flowOf$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  asFlow as asFlow3ngsnn5xpz8pw,
  callbackFlow as callbackFlow1g384rkuy0hni,
  channelFlow as channelFlow1or0c85tk04v1,
  flowOf as flowOf16f7h10nre075,
  flow as flow3tazazxj2t7g4,
};
//endregion

//# sourceMappingURL=Builders.mjs.map
